<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 45.615 19.72">
    <g id="Hybrid" transform="translate(0 0)">
      <path id="Path_86900" data-name="Path 86900"
        d="M1580.818,325.432a4.23,4.23,0,1,0-4.231-4.23,4.235,4.235,0,0,0,4.231,4.23m0-6.733a2.5,2.5,0,1,1-2.5,2.5,2.505,2.505,0,0,1,2.5-2.5"
        transform="translate(-1542.999 -305.712)" :fill="themeColor" />
      <path id="Path_86901" data-name="Path 86901"
        d="M1767.287,325.432a4.23,4.23,0,1,0-4.231-4.23,4.235,4.235,0,0,0,4.231,4.23m0-6.733a2.5,2.5,0,1,1-2.5,2.5,2.505,2.505,0,0,1,2.5-2.5"
        transform="translate(-1757.269 -305.712)" :fill="themeColor" />
      <path id="Path_86902" data-name="Path 86902"
        d="M1556.018,257.813h.73a.864.864,0,1,0,0-1.728h-.73c-.416,0-1.057-.747-1.587-2.409l.505-1.468a.842.842,0,0,0,.04-.165l.539-3.966a12.549,12.549,0,0,1,3.234-3.371c2.021-1.35,14.862-2.44,20.045-.445a13.924,13.924,0,0,1,3.52,2.345,13.18,13.18,0,0,0,2.765,1.919,24.138,24.138,0,0,0,4,1.013c2.016.413,4.524.928,5.347,1.506.938.66,1.813,3.923,2.135,6.028a.864.864,0,1,0,1.707-.261c-.148-.969-.981-5.867-2.849-7.181-1.117-.786-3.6-1.294-5.994-1.786a25.029,25.029,0,0,1-3.648-.9,12.18,12.18,0,0,1-2.366-1.674,15.384,15.384,0,0,0-3.994-2.62c-5.5-2.117-19.03-1.114-21.625.621a14.2,14.2,0,0,0-3.847,4.063.868.868,0,0,0-.115.326l-.553,4.067-.569,1.653a.862.862,0,0,0-.012.526c.954,3.23,2.334,3.907,3.323,3.907"
        transform="translate(-1552.659 -241.453)" :fill="themeColor" />
      <path id="Path_86903" data-name="Path 86903"
        d="M1639.858,341.281h15.834a.864.864,0,1,0,0-1.728h-15.834a.864.864,0,1,0,0,1.728"
        transform="translate(-1623.812 -324.927)" :fill="themeColor" />
      <path id="Path_86904" data-name="Path 86904"
        d="M1658.716,274.886l.009-1.728s-19.1-.1-22.544-.1c-2.672,0-3.4-.807-3.4-.815a.864.864,0,1,0-1.5.857c.161.281,1.153,1.686,4.9,1.686,3.437,0,22.536.1,22.536.1"
        transform="translate(-1624.813 -267.285)" :fill="themeColor" />
      <path id="Path_86905" data-name="Path 86905"
        d="M1805.911,250.592l.059,0,3.862-.259a.863.863,0,0,0,.8-.919.853.853,0,0,0-.92-.8l-3.862.259a.864.864,0,0,0,.057,1.725"
        transform="translate(-1802.651 -247.539)" :fill="themeColor" />
    </g>
  </svg>
</template>

<script>
import { mapWritableState } from 'pinia';
import { useChatSettingsStore } from '../../../../store/ChatSettingsStore/ChatSettingsStore';

export default {
  props: {
    themeColor: {
      type: String,
      required: false,
      default: '#B3B3B3',
    },
    isHoverUser: {
      type: Boolean,
      required: false,
      default: false,
    },
    height: {
      type: String,
      required: false,
      default: '50px',
    },
    width: {
      type: String,
      required: false,
      default: '100px',
    },
  },
  data() {
    return {
      themePrimaryColor: window.primaryColor,
    }
  },
  computed: {
    ...mapWritableState(useChatSettingsStore, ['chatThemeSettings']),
  },
}
</script>
